/** How many days before today (IST) may still be selected for reference. */
export const MAX_PAST_REFERENCE_DAYS = 3;

export function getISTDateString(offsetDays = 0) {
  const now = new Date();
  const istDate = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  istDate.setDate(istDate.getDate() + offsetDays);
  
  const year = istDate.getFullYear();
  const month = String(istDate.getMonth() + 1).padStart(2, '0');
  const day = String(istDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Earliest selectable date: today (IST) minus MAX_PAST_REFERENCE_DAYS. */
export function getEarliestSelectableDate() {
  return getISTDateString(-MAX_PAST_REFERENCE_DAYS);
}

/** True if dateString (YYYY-MM-DD) is on or after the earliest selectable date. */
export function isDateWithinSelectableRange(dateString) {
  if (!dateString) return false;
  return dateString >= getEarliestSelectableDate();
}

/**
 * Clamp a date to the allowed window (not earlier than today−3).
 * Returns { date, wasClamped }.
 */
export function clampToSelectableDate(dateString) {
  const minDate = getEarliestSelectableDate();
  if (!dateString || dateString < minDate) {
    return { date: minDate, wasClamped: true };
  }
  return { date: dateString, wasClamped: false };
}

/**
 * Move a YYYY-MM-DD date by whole days. Built through Date so month ends,
 * month lengths and leap days stay correct; string maths would not.
 */
export function shiftDateString(dateString, deltaDays) {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day + deltaDays);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Apply min=today−3 on a date input so older days are locked in the picker. */
export function applyDateInputLimits(inputEl) {
  if (!inputEl) return;
  inputEl.min = getEarliestSelectableDate();
  inputEl.removeAttribute('max');
}

export function formatDateForDisplay(dateString) {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function updateDateBadges(dateString) {
  const displayDate = formatDateForDisplay(dateString);
  document.querySelectorAll('.dateBadgeText').forEach(el => {
    el.textContent = displayDate;
  });
}
